import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL + '/api/admin/v1/claimnotification/'


export const notificationApiService = {
    get,
    cancel,
    cancelForUser
}

function get(payload) {
    return axios.post(baseUrl + 'get', payload)
}

function cancel(payload) {
    return axios.post(baseUrl + 'cancel', payload)
}

function cancelForUser(payload) {
    return axios.post(baseUrl + 'cancel/foruser', payload)
}